import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const FEEDBACK_DATE_FORMAT = 'MMM D, YYYY';
const ORDER_TIME_FORMAT = 'h:mm A';
const TIMEZONE_DESIGNATOR_REGEX = /(Z|[+-]\d{2}:?\d{2})$/i;

/**
 * Parses an API timestamp. Values without a timezone designator are UTC
 * and are converted to the user's local time.
 */
const parseApiDate = (value: string) =>
  (TIMEZONE_DESIGNATOR_REGEX.test(value) ? dayjs(value) : dayjs.utc(value)).local();

/**
 * Formats an ISO date string for feedback cards (e.g. "May 23, 2025").
 * Returns '-' when the value is empty or not a valid date.
 */
export const formatFeedbackDate = (value: string | undefined, locale: string): string => {
  if (!value) return '-';
  const parsed = parseApiDate(value);
  return parsed.isValid() ? parsed.locale(locale).format(FEEDBACK_DATE_FORMAT) : '-';
};

/** Formats the date part of an order timestamp (e.g. "May 23, 2025"). */
export const formatOrderDate = formatFeedbackDate;

/**
 * Formats the time part of an order timestamp (e.g. "3:45 PM").
 * Returns '-' when the value is empty or not a valid date.
 */
export const formatOrderTime = (value: string | undefined, locale: string): string => {
  if (!value) return '-';
  const parsed = parseApiDate(value);
  return parsed.isValid() ? parsed.locale(locale).format(ORDER_TIME_FORMAT) : '-';
};
